import { useCallback } from "react";
import urlStateService from "../../services/urlStateService";
import { updateUrlState } from "../helpers/stateHelpers";

/**
 * Hook for managing URL state synchronization
 * @returns {Object} Object containing URL sync functions
 */
export const useCatalogueUrlSync = () => {
  /**
   * Synchronizes URL state with current filters and UI state
   * @param {Object} filters - Current filter state
   * @param {Object} uiState - Current UI state
   */
  const syncUrlState = useCallback((filters, uiState) => {
    updateUrlState(filters, uiState, urlStateService);
  }, []);

  return {
    syncUrlState,
    urlStateService,
  };
};
